import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=6330%3A13038
 *
 * @param {SvgIconProps} props - svg props
 */
export const InfotipIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0Z' fill={color}/>
            <path fillRule='evenodd' clipRule='evenodd' d='M11.5 5.5C11.5 6.32843 10.8284 7 10 7C9.17157 7 8.5 6.32843 8.5 5.5C8.5 4.67157 9.17157 4 10 4C10.8284 4 11.5 4.67157 11.5 5.5ZM11.5 13.9783C11.5 14.8187 10.8284 15.5 10 15.5C9.17157 15.5 8.5 14.8187 8.5 13.9783V10.0217C8.5 9.18131 9.17157 8.5 10 8.5C10.8284 8.5 11.5 9.18131 11.5 10.0217V13.9783Z' fill='white'/>
        </SvgIcon>
    )
}

export default InfotipIcon
